import React from "react";
import MainLayout from "../../layouts/MainLayout";
import { GuadalarajaModal } from "../../components/working-at-forager-current-oppotunities/guadalaraja";
import AppModal from "../../components/common/AppModal";
import CardModal from "../../components/CardModal";
import { NavLink } from "react-router-dom";
import rocket from "../../assets/img/about/rockets.png";
import working from "../../assets/img/working/working.png";

function WorkingAtForager() {
  const show = false;

  const cards = [
    {
      image: require("../../assets/img/working/orange.png"),
      title: "Lorem ipsum dolor 1",
      subtitle: "sbutitle",
      className: "col-span-4 lg:col-span-1",
      modalContent: <GuadalarajaModal />,
    },
    {
      image: require("../../assets/img/working/building.png"),
      title: "Lorem ipsum dolor 2",
      subtitle: "sbutitle",
      className: "col-span-2 lg:col-span-1",
      modalContent: <GuadalarajaModal />,
    },
    {
      image: require("../../assets/img/working/table.png"),
      title: "Lorem ipsum dolor 3",
      subtitle: "sbutitle",
      className: "col-span-2 lg:col-span-2",
      modalContent: <GuadalarajaModal />,
    },
    {
      image: require("../../assets/img/working/orange.png"),
      title: "Lorem ipsum dolor 1",
      subtitle: "sbutitle",
      className: "col-span-2 lg:col-span-2",
      modalContent: <GuadalarajaModal />,
    },
    {
      image: require("../../assets/img/working/building.png"),
      title: "Lorem ipsum dolor 2",
      subtitle: "sbutitle",
      className: "col-span-2 lg:col-span-1",
      modalContent: <GuadalarajaModal />,
    },
    {
      image: require("../../assets/img/working/table.png"),
      title: "Lorem ipsum dolor 3",
      subtitle: "sbutitle",
      className: "col-span-2 lg:col-span-1",
      modalContent: <GuadalarajaModal />,
    },
  ];
  return (
    <MainLayout>
      <section className="bg-dark-denim">
        <section className="bg-dark-denim md:pb-28">
          <div className="app-forager-international-working with-curved-bottom bg-no-repeat bg-cover px-0 pt-5">
            <div className="h-48 md:h-44 lg:mt-14 grid place-items-center">
              <h1 className="text-white text-4xl lg:text-6xl">
                working at forager
              </h1>
            </div>
          </div>
          <div className="container mx-auto grid grid-cols-1 lg:grid-cols-7 justify-center items-center gap-x-8 mt-14 relative">
            <img
              src={rocket}
              alt=""
              className="hidden lg:block absolute -top-24 left-24 w-1/3 -rotate-6 xl:-rotate-3 2xl:-rotate-2 mt-4"
            />
            <figure className="lg:col-span-3 mx-auto px-4 mb-10 text-white">
              <p className="pr-0.5 lg:tracking-[0.01em]">
                All Forager businesses strive for inclusive and representative
                teams. We actively search for ways to engage with
                underrepresented communities and find skills-sharing
                opportunities to allow candidates with the potential but not
                necessarily the developed experience to find the confidence to
                become active and productive members of the Forager community.
              </p>
              <p className="mt-5">
                All of our roles are fully or partially remote because we
                believe a workspace that allows teams to work from wherever
                inspires the same exploration that we actively try to create
                through the projects we develop with partners.
              </p>
            </figure>
            <div
              className="lg:col-span-4 w-full h-[20rem] xl:h-[24rem] mx-auto md:rounded-lg bg-cover"
              style={{
                backgroundImage: `url(${working})`,
              }}
            />
          </div>
        </section>

        <div className="bg-white px-4 pt-14">
          <div className="container mx-auto">
          <h2 className="mb-14 text-center text-navy-blue text-3xl md:text-4xl with-line-above before:w-36 before:border-navy-blue line-above-center">
            current opportunities
          </h2>
          {show ? (
            <>
              <div className="max-w-lg lg:max-w-none mx-auto grid grid-cols-4 gap-5">
                {cards.map((card) => (
                  <div key={card.title} className={card.className}>
                    <AppModal activator={<CardModal card={card} />}>
                      {card.modalContent}
                    </AppModal>
                  </div>
                ))}
              </div>
              <div className="pt-16 pb-32 max-w-md mx-auto">
                <NavLink
                  to="/"
                  className="w-80 lg:w-full block py-4 mx-auto rounded-full bg-navy-blue text-center text-white font-bold shadow-lg"
                >
                  button
                </NavLink>
              </div>
            </>
          ) : (
            <p className="text-xl lg:text-2xl pt-10 pb-28 text-center font-medium text-dark-denim">
              no current opportunities!
            </p>
          )}
          </div>
        </div>
      </section>
    </MainLayout>
  );
}

export default WorkingAtForager;
